var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLapun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 163,
    viewBox: "0 0 126 163",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.391 111.668C68.5371 112.986 57.1765 121.322 56.2106 135.568C55.8096 141.502 57.3524 146.34 58.6211 149.298C59.7179 149.29 61.1707 149.483 62.5499 150.326C65.4432 152.094 66.8551 156.026 66.1512 160.27C52.1959 160.667 38.2366 161.064 24.2813 161.457C20.3976 154.529 23.1395 145.848 29.712 142.534C35.6952 139.513 43.4667 141.641 47.285 147.739C45.959 144.793 43.2089 137.602 44.6535 128.505C46.6507 115.941 55.2162 108.771 57.3688 107.068C61.7068 108.603 66.0489 110.134 70.3869 111.668H70.391Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M74.8156 99.9194C73.3996 112.058 78.2983 122.346 86.0412 125.354C87.6373 125.972 90.989 126.921 95.8468 125.657C95.9409 123.819 96.4893 122.489 96.874 121.728C97.2055 121.073 98.822 117.898 101.412 117.685C101.412 117.685 102.501 117.66 103.733 118.262C109.638 121.167 108.427 151.415 108.005 159.997H84.347C82.6772 155.069 83.8804 150.252 86.9743 148.165C88.5417 147.109 90.3097 146.946 91.607 147.015C92.4991 143.676 93.3913 140.332 94.2834 136.993C90.7476 137.05 83.2297 136.637 76.1089 131.742C60.8931 121.282 62.5997 100.709 62.6856 99.8457C66.7289 99.8703 70.7723 99.8948 74.8115 99.9194H74.8156Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5918 113.262L66.4592 120.346L79.2767 119.986L75.172 111.961L62.5918 113.262Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3086 115.39L58.7309 124.983L67.4191 109.738L56.6642 107.336L50.3086 115.39Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1558 104.655C40.7687 105.813 31.7735 108.899 24.8449 117.292C22.68 119.916 21.1413 122.539 20.0404 124.872C23.9323 129.84 24.2024 134.788 22.4058 136.212C20.9121 137.394 17.5931 136.461 14.532 134.284C8.61836 135.966 3.43732 135.545 1.59162 132.831C1.03914 132.017 -0.446421 129.185 4.81647 120.521C8.97441 113.679 18.2643 101.676 40.0075 89.791",
    fill: "#5B5BD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1558 104.655C40.7687 105.813 31.7735 108.899 24.8449 117.292C22.68 119.916 21.1413 122.539 20.0404 124.872C23.9323 129.84 24.2024 134.788 22.4058 136.212C20.9121 137.394 17.5931 136.461 14.532 134.284C8.61836 135.966 3.43732 135.545 1.59162 132.831C1.03914 132.017 -0.446421 129.185 4.81647 120.521C8.97441 113.679 18.2643 101.676 40.0075 89.791",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4886 130.826C7.83265 134.996 7.15739 139.33 8.32783 141.237C8.85576 142.097 9.75201 142.449 10.5418 142.314C12.6167 141.962 14.7694 138.111 15.4323 132.623",
    fill: "#5B5BD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4886 130.826C7.83265 134.996 7.15739 139.33 8.32783 141.237C8.85576 142.097 9.75201 142.449 10.5418 142.314C12.6167 141.962 14.7694 138.111 15.4323 132.623",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81585 129.021C5.44344 129.627 5.05056 130.36 4.69861 131.215C4.23616 132.349 3.97015 133.388 3.81055 134.243",
    fill: "#5B5BD8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M5.81585 129.021C5.44344 129.627 5.05056 130.36 4.69861 131.215C4.23616 132.349 3.97015 133.388 3.81055 134.243",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6055 147.019C92.4649 147.22 93.5862 147.58 94.7812 148.259C95.4933 148.664 96.0826 149.098 96.5573 149.499L93.5985 139.555L91.6055 147.015V147.019Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.439 107.343C105.769 107.343 110.089 103.023 110.089 97.693C110.089 92.3634 105.769 88.043 100.439 88.043C95.1095 88.043 90.7891 92.3634 90.7891 97.693C90.7891 103.023 95.1095 107.343 100.439 107.343Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3309 54.2477C62.1643 54.436 63.9978 54.6202 65.8312 54.8084C66.7111 48.8703 73.4677 5.44114 90.1158 1.6679C91.1103 1.44281 92.7391 1.09905 94.4293 1.8316C105.123 6.47244 97.2408 44.9579 95.3378 53.8221C105.659 73.2613 104.001 94.628 92.3871 105.903C82.8599 115.148 68.79 115.508 65.6102 115.594C63.6827 115.643 48.3932 115.868 38.9192 107.871C12.1464 85.2644 42.8234 6.20234 61.8697 1.38552C62.9296 1.11542 65.8148 0.386961 67.6892 1.89298C71.5811 5.02371 67.3945 14.8088 64.1369 29.0669C62.7578 35.1073 61.1535 43.6524 60.335 54.2436L60.3309 54.2477Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5117 47.2318C77.6781 41.8216 79.2659 35.8384 81.4472 29.4501C83.8004 22.5543 86.4196 16.4402 89.0019 11.1445",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6602 44.4088C42.5018 39.1909 44.8304 33.4533 47.7974 27.3924C51.0018 20.8485 54.3699 15.1109 57.5988 10.1836",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M27.694 82.1126C27.694 89.5645 33.735 95.6055 41.1869 95.6055C48.6387 95.6055 54.6797 89.5645 54.6797 82.1126V79.6735C54.6797 72.2217 48.6387 66.1807 41.1869 66.1807C33.735 66.1807 27.694 72.2217 27.694 79.6735L27.694 82.1126Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2238 89.8698C38.5802 89.8698 41.3011 86.0037 41.3011 81.2347C41.3011 76.4657 38.5802 72.5996 35.2238 72.5996C31.8674 72.5996 29.1465 76.4657 29.1465 81.2347C29.1465 86.0037 31.8674 89.8698 35.2238 89.8698Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2734 92.4668L34.957 85.6406L42.8841 86.942L37.2734 92.4668Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9473 77.0672C28.2706 75.6716 29.2814 72.189 32.4694 69.5289C36.5291 66.1403 42.8929 65.0967 48.033 68.1129C54.3436 71.8166 54.6669 79.2034 54.6792 79.67C45.7699 78.8024 36.8565 77.9348 27.9473 77.0672Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6374 81.7748C50.6374 89.2266 56.6783 95.2676 64.1302 95.2676C71.5821 95.2676 77.623 89.2266 77.623 81.7748V79.3357C77.623 71.8838 71.5821 65.8428 64.1302 65.8428C56.6783 65.8428 50.6374 71.8838 50.6374 79.3357V81.7748Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1671 89.5299C61.5235 89.5299 64.2444 85.6639 64.2444 80.8948C64.2444 76.1258 61.5235 72.2598 58.1671 72.2598C54.8107 72.2598 52.0898 76.1258 52.0898 80.8948C52.0898 85.6639 54.8107 89.5299 58.1671 89.5299Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2206 92.1369L57.9043 85.3066L65.8314 86.608L60.2206 92.1369Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8906 76.7332C51.2139 75.3377 52.2248 71.855 55.4128 69.1949C59.4725 65.8063 65.8363 64.7628 70.9764 67.7789C77.2869 71.4826 77.6103 78.8694 77.6225 79.336C68.7133 78.4684 59.7999 77.6008 50.8906 76.7332Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9272 54.2339L62.1386 52.2273C60.1021 51.8806 58.1702 53.2505 57.8235 55.2871L57.5742 56.7516C57.2276 58.7881 58.5975 60.7201 60.634 61.0667L72.4226 63.0733C74.4592 63.4199 76.3911 62.05 76.7378 60.0135L76.987 58.549C77.3337 56.5125 75.9638 54.5805 73.9272 54.2339Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6841 61.6089L42.4727 59.6023C44.5092 59.2556 45.8791 57.3237 45.5325 55.2871L45.2832 53.8226C44.9366 51.7861 43.0046 50.4162 40.9681 50.7628L29.1795 52.7694C27.143 53.1161 25.773 55.048 26.1197 57.0846L26.369 58.5491C26.7156 60.5856 28.6476 61.9555 30.6841 61.6089Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3987 98.5138C48.3087 102.013 50.9238 104.607 53.3629 104.632C56.0475 104.661 58.9573 101.575 58.327 97.6953C55.0162 97.9654 51.7095 98.2396 48.3987 98.5097V98.5138Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3613 88.3354C84.7484 87.1772 93.7436 84.0915 100.672 75.6979C102.837 73.0746 104.376 70.4513 105.477 68.1186C101.585 63.1504 101.315 58.2026 103.111 56.7785C104.605 55.5957 107.924 56.5288 110.985 58.706C116.899 57.024 122.08 57.4455 123.925 60.1588C124.478 60.9732 125.964 63.8052 120.701 72.4689C116.543 79.3115 107.253 91.3147 85.5096 103.199",
    fill: "#5B5BD8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M80.3613 88.3354C84.7484 87.1772 93.7436 84.0915 100.672 75.6979C102.837 73.0746 104.376 70.4513 105.477 68.1186C101.585 63.1504 101.315 58.2026 103.111 56.7785C104.605 55.5957 107.924 56.5288 110.985 58.706C116.899 57.024 122.08 57.4455 123.925 60.1588C124.478 60.9732 125.964 63.8052 120.701 72.4689C116.543 79.3115 107.253 91.3147 85.5096 103.199",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M115.034 62.164C117.69 57.9938 118.365 53.6599 117.194 51.7528C116.666 50.8934 115.77 50.5414 114.98 50.6765C112.905 51.0284 110.753 54.8794 110.09 60.3674",
    fill: "#5B5BD8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M115.034 62.164C117.69 57.9938 118.365 53.6599 117.194 51.7528C116.666 50.8934 115.77 50.5414 114.98 50.6765C112.905 51.0284 110.753 54.8794 110.09 60.3674",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M119.701 63.9622C120.074 63.3565 120.466 62.624 120.818 61.7686C121.281 60.635 121.547 59.5956 121.706 58.7402",
    fill: "#5B5BD8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M119.701 63.9622C120.074 63.3565 120.466 62.624 120.818 61.7686C121.281 60.635 121.547 59.5956 121.706 58.7402",
    stroke: "#1E1E1E",
    strokeWidth: 1.94094,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLapun);
export default __webpack_public_path__ + "static/media/lapun.de5106f013f608807e434625c3b36dcf.svg";
export { ForwardRef as ReactComponent };